import { useState } from 'react';
import {
  Alert,
  Button,
  Card,
  CardContent,
  FormControlLabel,
  Switch,
  Typography,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import PageHeader from '../components/common/PageHeader';
import { useAuth } from '../context/AuthContext';
import { useThemeMode } from '../theme/ThemeModeProvider';
import { authService } from '../services/authService';
import { getErrorMessage } from '../utils/format';
import { useNavigate } from 'react-router-dom';

export default function Settings() {
  const { logout } = useAuth();
  const { isDark, setMode } = useThemeMode();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogoutAll = async () => {
    setLoading(true);
    setError('');
    try {
      await authService.logoutAll();
      setMessage('All sessions revoked. Please sign in again.');
      await logout();
      navigate('/login');
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHeader title="Settings" subtitle="Application preferences and security" />

      {message && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {message}
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Appearance
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={isDark}
                onChange={e => setMode(e.target.checked ? 'dark' : 'light')}
              />
            }
            label="Dark mode"
          />
        </CardContent>
      </Card>

      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            API Configuration
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Gateway URL
          </Typography>
          <Typography variant="body1" fontFamily="monospace">
            {import.meta.env.VITE_API_URL || '(vite proxy → localhost:8080)'}
          </Typography>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Security
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={2}>
            Revoke all active sessions across devices.
          </Typography>
          <Button
            variant="outlined"
            color="error"
            startIcon={<LogoutIcon />}
            onClick={handleLogoutAll}
            disabled={loading}
          >
            Logout All Sessions
          </Button>
        </CardContent>
      </Card>
    </>
  );
}
